@if (shouldShowMarkerSection()) {
	<section class="form-group markers-group">
		<ng-container *ngIf="!hasMarkerSet; else existingMarkerSet">
			<section>
				<button
					type="button"
					class="link-btn add-btn markers-btn"
					translate="activity-editor-new_markers"
					(click)="openMarkerSelectionModal()">
				</button>
			</section>
		</ng-container>

		<ng-template #existingMarkerSet>
			<marker-set-panel
				class="first-auxiliary"
				[markerSet]="selectedMarkerSet"
				[activity]="activity"
				(onEdited)="handleMarkerSetEdited($event)"
				(onRemoved)="handleMarkerSetRemoved()">
			</marker-set-panel>
		</ng-template>
	</section>
}
